/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderObject from "App/geometry/objects/object";

import {
    TransformNodeTypeName,
    MaterialNodeTypeName,
    RenderOptionNodeTypeName,
    ShapeBatchNodeTypeName,
    TextureNodeTypeName
} from "App/render/webgl/nodes/type_names";

export enum ERenderableFilters {
    "material" = 1,
    "texture" = 2,
    "renderOptions" = 4
}

export default
class RenderState {

    private _renderablesFilter: number = 0; /// this is for rendering renderable in render nodes the difference from render

    // this contains a number which expresses what shapes/options will be e.g. rendered during
    // the render graph traversal - keepCameraAbove, pickable, alwaysOnTop, etc.
    private renderNodesFilter: any = {};
    private _geometryObject: RenderObject = null;

    constructor() {

        this.renderNodesFilter[TransformNodeTypeName] = 0;
        this.renderNodesFilter[TextureNodeTypeName] = 0;
        this.renderNodesFilter[MaterialNodeTypeName] = 0;
        this.renderNodesFilter[RenderOptionNodeTypeName] = 0;
        this.renderNodesFilter[ShapeBatchNodeTypeName] = 0;
    }

    /***
     * This enabled s
     * @param aTypes
     */
    public setRenderablesFilters(aFilters: string[]) {
        this._renderablesFilter = 0;
        for (let filter of aFilters) {
            this._renderablesFilter = this._renderablesFilter | ERenderableFilters[filter];
        }
    }

    public getRenderableFilterIsSet(aFilter: number): boolean {
        return (this._renderablesFilter & aFilter) !== 0;
    }

    public resetRenderablesFilters() {
        this._renderablesFilter = 0;
    }

    public setRenderNodesFilters(aFilters: {type: string, value: number}[]) {
        if (aFilters === undefined) {
            return;
        }

        for (let filter of aFilters) {
            this.renderNodesFilter[filter.type] = filter.value;
        }
    }

    public getRenderFilterValue(aType: string): number {
        let value = this.renderNodesFilter[aType];
        if (value === undefined) {
            value = 0;
        }

        return value;
    }

    public resetRenderNodesFilters() {
        for (let key in this.renderNodesFilter) {
            this.renderNodesFilter[key] = 0;
        }
    }

    public setRenderSingleGeometryObject(aObject: RenderObject) {
        this._geometryObject = aObject;
    }

    public getRenderedSingleGeometryObject(): RenderObject {
        return this._geometryObject;
    }
}
